export default {
	video: { title: 'Kan inte spela upp video', text: 'Du måste vara inloggad för att spela upp innehållet' },
	pdf: { title: 'Kan inte visa filen', text: 'Du måste vara inloggad för att visa innehållet' },
	formlink: { title: 'Kan inte öppna länken', text: 'Du måste vara inloggad för att visa innehållet' },
	noContent: { title: 'Inget innehåll publicerat', text: 'Inget innehåll har publicerats för denna uppgift.' },
	notSubscribed: { title: 'Ingen åtkomst', text: 'Profilen stöder inte att innehållet hämtas.' },
	unknownVideoError: { title: 'Okänt fel', text: 'Kunde inte spela upp den här videon' }	
};
